import { apiConstants } from '../../common/constants'
import ChannelConfigCard from './ChannelConfigCard';

const ChannelOrderAddress = ({ merchantId, setReload, data }) => (
    <ChannelConfigCard
        merchantId={merchantId}
        setReload={setReload}
        data={data}
        pricingType="channel_orders_address_verification_WA"
        endpoint={apiConstants.CHANNEL_ADDRESS_VERIFICATION}
        configType="channel_orders_address_verification"
        title="Order Address Verification WhatsApp (Webstore Orders)"
        description="Verify the delivery address on WhatsApp for webstore orders before processing."
        unitLabel="verification message sent"
    />
);

export default ChannelOrderAddress;
